module.exports = function () {
    this.currentUrl = window.location.pathname + window.location.search
}


// WEBPACK FOOTER //
// ./core/xhr2/modules/getUrl.js